import React from "react";
import { motion } from "framer-motion";
import { crmWhatsAppFeatures } from "../../data/crmPageContent";
import { CrmWhatsAppMockup } from "./CrmMockups";
import { CrmReveal, CrmStagger, CrmStaggerItem } from "./CrmMotion";

export const CrmWhatsAppSection = () => (
    <section className="crm-wa">
        <div className="crm-container crm-wa__split">
            <CrmReveal className="crm-wa__copy">
                <h2 className="crm-h2">WhatsApp CRM Integration</h2>
                <p className="crm-lead">
                    Turn every WhatsApp conversation into a tracked sales opportunity — without leaving your CRM.
                </p>

                <CrmStagger className="crm-wa__features">
                    {crmWhatsAppFeatures.map((f) => {
                        const Icon = f.icon;
                        return (
                            <CrmStaggerItem key={f.title}>
                                <motion.div className="crm-wa__feature" whileHover={{ x: 6 }}>
                                    <div className="crm-wa__feature-icon">
                                        <Icon size={18} />
                                    </div>
                                    <div>
                                        <strong>{f.title}</strong>
                                        <p>{f.description}</p>
                                    </div>
                                </motion.div>
                            </CrmStaggerItem>
                        );
                    })}
                </CrmStagger>
            </CrmReveal>

            <CrmReveal delay={0.12} className="crm-wa__chat">
                <CrmWhatsAppMockup />
            </CrmReveal>
        </div>
    </section>
);
